import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/fr';

function NewsCard({ id, title, date, author, img }) {
    // Format the date to a more readable format
    moment.locale();
    const formatDate = moment(date).format('DD MMMM YYYY');

    return (
        <Link to={`/actualites/${id}`} id="news-card">
            <div id="news-content">
                <p id="news-title">{title}</p>
                <div className="news-info">
                    <p>{formatDate}</p>
                    <p>{author}</p>
                </div>
            </div>
            <img src={img} alt="l'actualité" />
        </Link>
    );
}

// Prop types for the NewsCard component
NewsCard.propTypes = {
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
};

export default NewsCard;
